import React, { PureComponent } from 'react';

// @ts-ignore TODO: fix noImplicitAny error here
import { createPatch } from 'diff';

import Diff, { ChunkEntry } from '@atlassian/bitkit-diff';
// @ts-ignore TODO: fix noImplicitAny error here
import parseDiff from '@atlassian/diffparser';

const CONTEXT_LINES = 3;

type Props = {
  filename: string;
  newText: string;
  oldText: string;
  isColorBlindModeEnabled: boolean;
  isSyntaxHighlightingEnabled: boolean;
};

export default class TextDiff extends PureComponent<Props> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    filename: 'file',
  };

  parseDiff = (diff: string) => {
    const parsedDiff = parseDiff(diff)[0];

    const parsedChunks = parsedDiff.chunks.map((c: ChunkEntry) => ({
      ...c,
      extra: {
        isLoadingAbove: false,
        isLoadingBelow: false,
        after: {
          hasMoreLines: false,
        },
        before: {
          hasMoreLines: false,
        },
      },
    }));

    return { ...parsedDiff, chunks: parsedChunks };
  };

  render() {
    const {
      filename,
      newText,
      oldText,
      isColorBlindModeEnabled,
      isSyntaxHighlightingEnabled,
    } = this.props;
    const diff = createPatch(filename, oldText, newText, null, null, {
      context: CONTEXT_LINES,
    });

    return (
      <Diff
        isSideBySide={false}
        diff={this.parseDiff(diff)}
        onShowMoreLines={() => {}}
        isColorBlindModeEnabled={isColorBlindModeEnabled}
        isSyntaxHighlightingEnabled={isSyntaxHighlightingEnabled}
      />
    );
  }
}
